/**
 * youngchagoods-about の body 背景を、.rw-yancah-fv 下端から開始する。
 */
(function () {
  if (window.__rwYanchaAboutBgInit) return;
  window.__rwYanchaAboutBgInit = true;

  var mediaQuery = window.matchMedia('(min-width: 750px)');
  var observer = null;

  function applyPosition(offsetPx) {
    var pos = 'center ' + offsetPx + 'px';
    document.body.style.backgroundPosition = mediaQuery.matches ? pos : pos + ', center center';
  }

  function measure(fv) {
    var offset = Math.round(fv.getBoundingClientRect().bottom + window.scrollY);
    if (offset < 0) offset = 0;
    applyPosition(offset);
  }

  function init() {
    var fv = document.querySelector('.rw-yancah-fv');
    if (!fv) {
      document.body.style.backgroundPosition = '';
      return;
    }

    measure(fv);

    if (observer) observer.disconnect();
    observer = new ResizeObserver(function () {
      measure(fv);
    });
    observer.observe(fv);

    var header = document.getElementById('header-group');
    if (header) observer.observe(header);
  }

  function start() {
    init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', init);
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', init);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(init);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
